module.exports = __webpack_public_path__ + "img/followDoc_f.8804e435.png";